import { pageInfo, faceAccessSwitch } from '../api'
import { plantByPermission } from '../../../../../api'

const faceAccess = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: null,
    switchObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total
      state.pageResp = (data.obj || []).map(item => {
        // 设备状态着色：启用显示绿色，停用显示红色（兼容 status 数值与 statusName 文本两种返回）
        const isEnable = Number(item.status) === 1 || item.statusName === '启用'
        return {
          ...item,
          btns: [true],
          statusNameShowColor: true,
          statusNameColor: isEnable ? '#67C23A' : '#F56C6C'
        }
      })
    },
    PLANT(state, data) {
      state.plantObj = data
    },
    SWITCH(state, data) {
      state.switchObj = data
    }
  },
  actions: {
    // 查询事件
    async pageInfo({ commit }, obj) {
      const resp = await pageInfo(obj)
      commit('PAGE_INFO', resp)
    },
    async plant({ commit }, obj) {
      const resp = await plantByPermission(obj)
      commit('PLANT', resp)
    },
    // 启停事件
    async faceAccessSwitch({ commit }, obj) {
      const resp = await faceAccessSwitch(obj)
      commit('SWITCH', resp)
    }
  }
}
export default faceAccess



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/faceAccess/store/faceAccess.store.js